var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Chart Chart--column"},[_c('div',{staticClass:"Chart__Header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.hasData)?_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions}}):_c('p',{staticClass:"my-4",staticStyle:{"color":"gray"}},[_vm._v(" Geen data beschikbaar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }